import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import { Button } from '@mui/material';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import { SignupConfirmDialog } from './SignupConfirmDialog';

const ConfirmBeforeSignUp = (props) => {
  const { Component, confirmHeader, ...compProps } = props;

  const { enqueueSnackbar } = useSnackbar();

  const [open, setOpen] = useState(false);

  const handleClose = (variant, message) => {
    if (variant === 'success') {
      compProps.onClick();
    }
    if (variant === 'error') {
      enqueueSnackbar(message, { variant: 'error' });
    }
    setOpen(false);
  };

  const openDialog = () => {
    setOpen(true);
  };

  return (
    <>
      <Component {...compProps} onClick={openDialog} />
      {open && (
        <SignupConfirmDialog
          open={open}
          onClose={handleClose}
          header={confirmHeader}
        />
      )}
    </>
  );
};

const SignUp = ({ onClick, Icon }) => (
  <Button
    variant="contained"
    color="success"
    startIcon={Icon}
    onClick={onClick}
  >
    Sign Me Up!
  </Button>
);

const Withdraw = ({ onClick }) => (
  <Button
    variant="contained"
    color="error"
    startIcon={<CloseTwoToneIcon />}
    onClick={onClick}
  >
    Withdraw
  </Button>
);

 export const SignUpButton = (props) =>
  ConfirmBeforeSignUp({ Component: SignUp, ...props });

export const WithdrawButton = (props) =>
  ConfirmBeforeSignUp({ Component: Withdraw, ...props });
